import loadable from '@loadable/component';

import './ResetPassword.css';

export default loadable(() => {
  return import('./ResetPassword.jsx');
});
